import { DebtData } from '@common/hooks/useDebts/types';
import { COLOR_WARNING_50, IconMoney, BadgeInfo, Text } from '@consumidor-positivo/aurora';

interface InstallmentDataProps {
  debtData: DebtData;
  firstInstallmentExpDate: string;
}

const InstallmentDataCard = ({ debtData, firstInstallmentExpDate }: InstallmentDataProps) => {
  return (
    <div className="debit-account-page__card debit-account-page__card--installment">
      <div className="debit-account-page__card-title">
        <Text variant="heading-micro" weight="bold">
          Dados da parcela
        </Text>

        <BadgeInfo status="warning" text="Acordo em andamento" customIcon={<IconMoney rawColor={COLOR_WARNING_50} />} />
      </div>
      <div>
        <div className="debit-account-page__card-line">
          <Text color="secondary">Parcela 1 de {debtData.paymentOpt.qtyInstallment}:</Text>
          <Text color="secondary" weight="bold">
            {debtData.paymentOpt.display.entryValue}
          </Text>
        </div>
        <div className="closed-agreement-page__divider" />

        <div className="debit-account-page__card-line">
          <Text color="secondary">Vencimento:</Text>
          <Text color="secondary" weight="bold">
            {firstInstallmentExpDate}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default InstallmentDataCard;
